import React from "react";
import PropTypes from "prop-types";
import { Tag } from "antd";
import { Map } from "immutable";
import moment from "moment";
import _upperCase from "lodash/upperCase";
import _min from "lodash/min";
import _max from "lodash/max";
import { TABLE_DATA_TYPES } from "constants/table-data-types";
import { formatCurrency } from "../../utils/currency";
const DEFAULT_MAP = new Map({
    sum: null,
    average: null,
    min: null,
    max: null,
    count: null
});
class TableFooter extends React.Component {
    render() {
        /* eslint-disable no-unused-vars */
        const {
            data,
            selectedRowKeys,
            keyFilter,
            dataType,
            columnName
        } = this.props;
        let min_date, max_date;
        const filteredData = data
            .filter(_ =>
                selectedRowKeys.size === 0
                    ? true
                    : selectedRowKeys.includes(_[keyFilter])
            )
            .map(_ => _[columnName]);
        if (
            dataType === TABLE_DATA_TYPES.DATE &&
            typeof filteredData[1] === "string"
        ) {
            let convertedDates = filteredData.map(_ => moment(_, "DD-MM-YYYY"));
            min_date = moment.min(convertedDates).format("DD/MM/YYYY");
            max_date = moment.max(convertedDates).format("DD/MM/YYYY");
        }
        if (
            dataType === TABLE_DATA_TYPES.DATE &&
            typeof filteredData[0] !== "string"
        ) {
            min_date = moment.min(filteredData).format("DD/MM/YYYY");
            max_date = moment.max(filteredData).format("DD/MM/YYYY");
        }

        this.DATA_MAP = DEFAULT_MAP;
        switch (dataType) {
        case TABLE_DATA_TYPES.NUMBER:
            this.DATA_MAP = this.DATA_MAP.withMutations(map =>
                map
                    .set(
                        "sum",
                        filteredData.reduce((agg, _) => +_ + agg, 0)
                    )
                    .set("avg", map.get("sum") / filteredData.length)
                    .set("count", filteredData.length)
                    .set("min", _min(filteredData))
                    .set("max", _max(filteredData))
            );
            break;
        case TABLE_DATA_TYPES.CURRENCY:
            this.DATA_MAP = this.DATA_MAP.withMutations(map =>
                map
                    .set(
                        "sum",
                        formatCurrency(
                            filteredData.reduce((agg, _) => +_ + agg, 0)
                        )
                    )
                    .set(
                        "avg",
                        formatCurrency(
                            filteredData.reduce((agg, _) => +_ + agg, 0) /
                                    filteredData.length
                        )
                    )
                    .set("count", filteredData.length)
                    .set(
                        "min",
                        formatCurrency(
                            _min(filteredData.map(_ => parseInt(_)))
                        )
                    )
                    .set(
                        "max",
                        formatCurrency(
                            _max(filteredData.map(_ => parseInt(_)))
                        )
                    )
            );
            break;
        case TABLE_DATA_TYPES.DATE:
            this.DATA_MAP = this.DATA_MAP.withMutations(map =>
                map
                    .set("count", filteredData.length)
                    .set("min", min_date)
                    .set("max", max_date)
            );
            break;
        case TABLE_DATA_TYPES.STRING:
            this.DATA_MAP = this.DATA_MAP.withMutations(map =>
                map.set("count", filteredData.length)
            );
            break;
        default:
        }

        return this.DATA_MAP.filter(_ => !!_)
            .map((v, k) => (
                <Tag key={k} color={"rgb(16, 142, 233)"}>
                    {_upperCase(k)}: {v}
                </Tag>
            ))
            .toList();
    }
}

TableFooter.propTypes = {
    dataType: PropTypes.string,
    data: PropTypes.array,
    selectedRowKeys: PropTypes.object,
    columnName: PropTypes.string,
    keyFilter: PropTypes.string
};

export default TableFooter;
